exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#about h4[_v-056f0672]{text-align:center;margin-top:4rem;margin-bottom:2rem}#about .about-wrapper[_v-056f0672]{text-align:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-056f0672&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/About.vue
 ** module id = 28
 ** module chunks = 1
 **/